import { type FC } from "react";
import { Button } from "@uhg-harmony/react";

export interface ButtonBarProps {
  disabled?: boolean;
  onOpen?: () => void;
  closePreviewButton?: boolean;
  onClosePreview?: () => void;
}

export const ButtonBar: FC<ButtonBarProps> = ({
  disabled = false,
  onOpen,
  closePreviewButton = false,
  onClosePreview,
}) => (
  <div
      style={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%",
        marginTop: "clamp(16px, 4vw, 50px)",
        paddingRight: "clamp(8px, 3vw, 20px)",
        gap: "clamp(8px, 4vw, 28px)",
        flexWrap: "wrap",
      }}
    >
      {closePreviewButton && (
        <Button
          size="l"
          variant="secondary"
          disabled={disabled}
          onPress={onClosePreview}
          aria-label="Close template"
          style={{ marginLeft: "10px" }}
        >
          Close Preview
        </Button>
      )}

      <Button
        size="l"
        disabled={disabled}
        onPress={onOpen}
        aria-label="Open template"
      >
        Open
      </Button>
    </div>
);
